import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';

import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import HomeMainTest from './HomeMainTest';
import { Breadcrumbs } from '../../AbstractElements';

export default function MainTest() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Lab Tests")} parent={t("Home")} title={t("List of Lab Tests")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <HomeMainTest />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
